<template>
	<div  class="home">
		<div class="col-md-offset-1 col-md-10">
			<div class="panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					PRIVACY
				</div>

				<div style="padding:5px; text-align:left;">
                    FiledSafely&apos;s Privacy Policy is very simple:
                    <br><br>
                    <ul>
                        <li>Your data is stored safely and securely.</li>
                        <li>Your data is kept completely confidential, as per the Confidentiality Agreement below.</li>
                        <li>Your data is not used by FiledSafely other than to provide this service.</li>
                    </ul>  
				</div>
			</div>

			<div class="panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					CONFIDENTIALITY AGREEMENT
				</div>

				<div style="padding:5px; text-align:left;">
                    <table>
                        <tr>
                            <td style='padding:5px;'><b>Date:</b>
                            <td style='padding:5px;'><i>date file is received and stored</i></td>
                        </tr>

                        <tr>
                            <td style='padding:5px;'><b>Parties:</b>
                            <td style='padding:5px;'>
                                Filed Safely (the Recipient) -- and -- the sender of the file (the Discloser)
                            </td>
                        </tr>
                        <tr>
                            <td style='padding:5px; vertical-align:top;'><b>Terms:</b>
                            <td style='padding:5px;'>
                                <ol>
                                    <li style='padding-bottom:5px;'>
                                        The Discloser intends to submit data (the Confidential Information) to the Recipient for
                                        the purpose of Identification and Storage of the data submitted (the Purpose).
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        The Recipient undertakes not to use the Confidential Information for any purpose except the
                                        Purpose, without first obtaining the written agreement of the Discloser.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        The Recipient undertakes to keep the Confidential Information secure and not to disclose it to
                                        any third party except to its employees who need to know the
                                        same for the Purpose, who know they owe a duty of confidence to the Discloser and who are
                                        bound by obligations equivalent to those in clause 2 above and this clause 3.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        The undertakings in clauses 2 and 3 above apply to all of the information disclosed by the
                                        Discloser to the Recipient, regardless of the way or form in which it is disclosed or recorded but
                                        they do not apply to: 
                                        <br>
                                        a) any information which is or in future comes into the public domain (unless as a result of the
                                        breach of this Agreement); or
                                        <br>
                                        b) any information which is already known to the Recipient and which was not subject to any
                                        obligation of confidence before it was disclosed to the Recipient by the Discloser.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        Nothing in this Agreement will prevent the Recipient from making any disclosure of the
                                        Confidential Information required by law or by any competent authority.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        The Recipient will, on request from the Discloser, destroy all copies of the
                                        Confidential Information.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        Neither this Agreement nor the supply of any information grants the Recipient any licence,
                                        interest or right in respect of any intellectual property rights of the Discloser except the right to
                                        copy the Confidential Information solely for the Purpose. 
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        The undertakings in clauses 2 and 3 will continue in force indefinitely.
                                    </li>

                                    <li style='padding-bottom:5px;'>
                                        This Agreement is governed by, and is to be construed in accordance with, English law. The
                                        English Courts will have non-exclusive jurisdiction to deal with any dispute which has arisen or
                                        may arise out of, or in connection with, this Agreement.
                                    </li>
                                </ol>
                            </td>
                        </tr>
                    </table>
				</div>
			</div>
            <br><br>

		</div>
	</div>
</template>


<script>

export default {
	name: 'terms',

	components: {
	},
	
	data() {
		return {
			env: process.env.VUE_APP_ENV,
		}
	},
	
	created() {
	},

	mounted() {
	},

	destroyed() {
	},

	methods: {
	},
}

</script>
